<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered is-size-3">
                <span>
                    Cambiar la clave del usuario seleccionado
                </span>
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section style="background:#F8F9FD;" class="modal-card-body">
            <div style="background:#F8F9FD;" role="navigation" aria-label="main navigation" class="">
                <div class="">
                    <a class="mr-3 mb-3 button is-rounded" :class="{
                        'has-background-info-dark': selectedUser && selectedUser.user_id == user.user_id,
                        'has-background-info-light': selectedUser == null || selectedUser.user_id != user.user_id,
                        'has-text-white': selectedUser && selectedUser.user_id == user.user_id,
                        'has-text-black': selectedUser == null || selectedUser.user_id != user.user_id
                    }" @click="() => selectUser(user)" v-for="user in allUsers" v-bind:key="user.user_id">
                        {{ user.user_email }}
                    </a>
                </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <InputWithValidation id="username" name="username" label="Usuario:" v-model="username"
                        rules="email|required" :disabled="selectedUser == null" />
                </div>
            </div>

            <ValidationObserver>
                <div class="columns">
                    <div class="column is-6">
                        <InputWithValidation id="password" name="password" label="Contraseña:" v-model="password"
                            rules="required" vid="password" type="password" :disabled="selectedUser == null" />
                    </div>
                    <div class="column is-6">
                        <InputWithValidation id="repeatPassword" name="repeatPassword" label="Repite la contraseña:"
                            rules="confirmed:password|required" v-model="repeatPassword" type="password"
                            :disabled="selectedUser == null" />
                    </div>
                </div>
            </ValidationObserver>

        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
            <button class="button is-primary" :disabled="loading || disableUpdateBtn" role="button"
                @click="updateUser()">
                Grabar
            </button>
        </footer>
    </div>
</template>

<script>
import { updateUserPassword } from "@/api/security";
import InputWithValidation from "@/components/inputs/InputWithValidation";
import { consoleHandlerError, notificate } from "@/utils/message";
import { ValidationObserver } from "vee-validate";
export default {
    name: "ChangeUsernamePass",
    data() {
        return {
            loading: false,
            selectedUser: null,
            username: "",
            password: "",
            repeatPassword: "",
        };
    },
    components: {
        InputWithValidation,
        ValidationObserver
    },
    methods: {
        selectFiles(event, file) {
            file.active = event.target.checked
        },
        selectUser(user) {
            this.selectedUser = user
            this.username = user.user_email
        },
        updateUser() {
            const reqUserOps = {
                user_id: this.selectedUser.user_id,
                username: this.username,
                password: this.password,
            }
            updateUserPassword(reqUserOps).then(() => {
                notificate(
                    `<strong>Éxito!</strong><br>
                    Se actualizaron las credenciales`,
                    "is-success is-light"
                );
            }).catch(error => {
                const customDefaultMessage = `<strong>Error!</strong><br>
                    Sus credenciales no pueden estar vacias o usted no es superusuario`
                consoleHandlerError({ error, empty: true, customDefaultMessage });
            }).finally(() => {
                this.$emit("close");
            })
        }
    },
    computed: {
        disableUpdateBtn() {
            const invalidPass = this.password != this.repeatPassword || this.password == ""
            const invalidData = this.password == "" || this.username == ""
            return invalidData || invalidPass
        }
    },
    props: ["allUsers"],
    created() {
    },
};
</script>